import React from 'react';

interface Props {
  onCancel?: () => void;
}

const EventCancelPreviewButtonTw: React.FC<Props> = ({ onCancel }) => {
  return (
    <button
      type="button"
      className="flex-1 py-2 rounded border border-gray-300 text-gray-700 font-semibold hover:bg-gray-100 transition-all text-sm"
      onClick={onCancel}
    >
      Cancel
    </button>
  );
};

export default EventCancelPreviewButtonTw;
